import React, { FC, useState } from 'react'
import * as ModalStyles from '../../../../../../ModalWindow/modal.styles'
import * as LocalStyles from '../../../styles'
import TabTile from '../../../../../../../../data/components/TabTile'
import { QuestionAnswerSection } from '../../index'
import { QuestionTypeOption, TrainedQuestion } from '../../types'
import { KnowledgeQuestion } from '../../trained_questions/knowledge-question'

interface KnowledgeQuestionSectionProps {
  question: string
  answer: string
  dataSources: Record<string, boolean>
  onCreateNewQuestion?: (question: string, answer: string, questionType: string) => void
  onUpdate?: (id: string, questionBeforeUpdate: string, questionForUpdate: string, answer: string, questionType: string) => void
  buttonIsActive: boolean
  mostRelevantQuestion?: TrainedQuestion
  onQuestionWasChanged?: (active: boolean) => void
  initQuestionType: string
}

export const KnowledgeQuestionSectionWithRelevantQuestion: FC<KnowledgeQuestionSectionProps> = ({
  question,
  answer,
  dataSources,
  onUpdate,
  mostRelevantQuestion,
  onQuestionWasChanged,
  onCreateNewQuestion,
  initQuestionType,
}) => {
  const [expanded, setExpanded] = useState<boolean>(false)

  const handleToggleExpand = () => {
    setExpanded(!expanded)
  }
  const isAnyDataPresent = (): boolean => {
    return Object.entries(dataSources).some(([, present]) => present)
  }

  return (
    <>
      <QuestionAnswerSection
        question={question}
        answer={answer}
        questionTitle="Generated Task"
        answerTitle="Agent Answer"
      />
      {isAnyDataPresent() && (
        <ModalStyles.ModalContainerSection style={{ marginTop: '16px' }}>
          <ModalStyles.SubHeader> Data present in : </ModalStyles.SubHeader>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {Object.entries(dataSources)
              .filter(([, present]) => present)
              .map(([sourceName]) => (
                <LocalStyles.Tag key={sourceName}>{sourceName.replace('_', ' ')}</LocalStyles.Tag>
              ))}
          </div>
        </ModalStyles.ModalContainerSection>
      )}
      <TabTile
        tab={{
          name: <span>{'Closest Question'}</span>,
        }}
        expanded={expanded}
        onChange={handleToggleExpand}>
        <KnowledgeQuestion
          question={mostRelevantQuestion.question}
          answer={mostRelevantQuestion.answer}
          updateQuestionCallback={onUpdate}
          questionType={'relevant'}
          questionId={mostRelevantQuestion.trainingQuestionId}
          onQuestionWasChanged={onQuestionWasChanged}
          createQuestionCallback={onCreateNewQuestion}
          initQuestionType={initQuestionType}
        />
      </TabTile>
    </>
  )
}
